module.exports = __webpack_public_path__ + "static/media/whichThinnerQuestion.2f991dcf.mp3";